/* eslint-disable indent */
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { COLORS, newLayout } from '../../../../theme';

export const StyledTypography = styled(Typography)`
  && {
    font-size: ${newLayout.fontSize.body1};
  }
  display: inline;
  ${({ $settings }) =>
    $settings === 'noWrap' &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const StyledPrefix = styled(Typography)`
  display: inline;
  color: ${COLORS.black50};
  text-transform: capitalize;
  padding-right: ${({ theme }) => theme.spacing.s1};
`;
